var exports = {
  "Y2": "FriendListItem.module__friendListItem___QVRKUG",
  "lY": "FriendListItem.module__contextMenuActive___QVRKUG",
  "Hb": "FriendListItem.module__friendInfo___QVRKUG",
  "HX": "FriendListItem.module__friendDetails___QVRKUG",
  "Um": "FriendListItem.module__friendNameRow___QVRKUG",
  "G3": "FriendListItem.module__friendName___QVRKUG",
  "tf": "FriendListItem.module__friendTag___QVRKUG",
  "kC": "FriendListItem.module__friendSubtext___QVRKUG",
  "MI": "FriendListItem.module__friendStatusOffline___QVRKUG",
  "wh": "FriendListItem.module__friendStatusOnline___QVRKUG",
  "yA": "FriendListItem.module__friendActions___QVRKUG",
  "I0": "FriendListItem.module__actionButtonMessage___QVRKUG",
  "cQ": "FriendListItem.module__actionButtonMore___QVRKUG",
  "nl": "FriendListItem.module__contextMenuButtonActive___QVRKUG",
  "TI": "FriendListItem.module__actionButtonAccept___QVRKUG",
  "Tl": "FriendListItem.module__actionButtonIgnore___QVRKUG",
  "P7": "FriendListItem.module__actionButtonCancel___QVRKUG",
  "RK": "FriendListItem.module__iconSize___QVRKUG",
};

module.exports = exports;
